import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-8 max-w-md w-full text-center">
        <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-slate-100 mb-6">
          <span className="text-4xl font-bold text-slate-400">404</span>
        </div>
        <h1 className="text-xl font-bold text-slate-900 mb-2">Page not found</h1>
        <p className="text-sm text-slate-500 mb-6">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          className="inline-block bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl px-6 py-2.5 text-sm font-semibold hover:from-blue-700 hover:to-blue-800"
        >
          Go Home
        </Link>
      </div>
    </div>
  );
}
